export default {
  antiPhishingSetupTitle: 'anti-phishing-extension-title',
  antiPhishingSetupDescription: 'anti-phishing-extension-description',
  antiPhishingSetupTitleSuccess: 'anti-phishing-extension-title-success',
  antiPhishingSetupDescriptionSuccess:
    'anti-phishing-extension-description-success',
}
